export function ControlPointInstruction({ text, pointColor }) {
    if (!text) return null;
    return (
        <div style={{
            display: "grid",
            gap: "6px",
            width: "100%",
            padding: "10px",
            borderRadius: "8px",
            background: "#f8fafc",
            border: `1px solid ${pointColor}`,
        }}>
            <div style={{ color: "#0f172a", fontSize: "13px", fontWeight: 950, lineHeight: 1.45 }}>
                {text}
            </div>
        </div>
    );
}
